import {createSelector} from 'reselect';

import type {NutshellState} from '../../../store';

export const getAudienceState = (state: NutshellState) => state.audiences;

export const getAudienceMemberListState = createSelector(
    [getAudienceState],
    (audiencesState) => audiencesState.audienceMemberList
);

export const getIsFilterDrawerOpen = createSelector([getAudienceState], (audiencesState) => {
    return audiencesState.isFilterDrawerOpen;
});

export const getAudienceMemberListItems = createSelector(
    [getAudienceMemberListState],
    (audienceMemberListState) => {
        return audienceMemberListState.listItems;
    }
);

export const getAudienceMemberListIsLoading = createSelector(
    [getAudienceMemberListState],
    (audienceMemberListState) => {
        return audienceMemberListState.isLoading;
    }
);
export const getAudienceMemberListIsFirstLoad = createSelector(
    [getAudienceMemberListState],
    (audienceMemberListState) => {
        return audienceMemberListState.isFirstLoad;
    }
);
export const getAudienceMemberListHasError = createSelector(
    [getAudienceMemberListState],
    (audienceMemberListState) => {
        return Boolean(audienceMemberListState.errorMessage);
    }
);

export const getAudienceMemberListCount = createSelector(
    [getAudienceMemberListState],
    (audienceMemberListState) => {
        return audienceMemberListState.meta.count ? audienceMemberListState.meta.count : 0;
    }
);

// Membership report
const getAudienceMembershipReportState = createSelector(
    [getAudienceState],
    (reportState) => reportState.audienceMembershipReport
);

const getAudienceMembershipChartState = createSelector(
    [getAudienceMembershipReportState],
    (audienceMembershipReport) => audienceMembershipReport.timeseriesChart
);

export const getCurrentReportChartIsLoading = createSelector(
    [getAudienceMembershipChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);
export const isChartTimedOut = createSelector(
    [getAudienceMembershipChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = (state: NutshellState) =>
    getAudienceMembershipChartState(state).isErrored;

export const getCurrentReportChartData = createSelector(
    [getAudienceMembershipChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);
export const getCurrentReportChartPrefix = createSelector(
    [getAudienceMembershipChartState],
    (timeseriesChartState) => timeseriesChartState.prefix
);
export const getCurrentReportChartBucketCount = createSelector(
    [getCurrentReportChartData],
    (chartData) => (chartData ? chartData.buckets.length : 1)
);
